import { QuoteEmailAttachment } from "./email-attachment.model";

export class QuoteEmailAttachmentMapper {
  public static map(data: any): QuoteEmailAttachment {
    if (!data) {
      return null;
    }

    return new QuoteEmailAttachment(
      data.id ?? null,
      data.filename ?? null,
      data.sizeBytes ?? 0,
      data.mimeType ?? null,
      data.state ?? null,
      data.classification ?? null,
      data.classificationReason ?? null,
      data.scanVerdict ?? null,
      data.contributedFields ?? [],
      data.available ?? false,
      data.parentAttachmentId ?? null,
      data.deleteReason ?? null,
    );
  }

  /**
   * Files from an archive are nested under it, so the list reads the way the message arrived rather
   * than as a flat run of names with no hint where they came from.
   */
  public static mapAll(data: any): QuoteEmailAttachment[] {
    if (!Array.isArray(data)) {
      return [];
    }

    const attachments = data.map(QuoteEmailAttachmentMapper.map);
    const roots = attachments.filter((item) => !item.isChild());

    return roots.reduce(
      (ordered: QuoteEmailAttachment[], root: QuoteEmailAttachment) => [
        ...ordered,
        root,
        ...attachments.filter(
          (item) => item.getParentAttachmentId() === root.getId(),
        ),
      ],
      [],
    );
  }
}
